module.exports = __webpack_public_path__ + "img/main_music_d720.7da3fdef.png";